<template>
  <div>
    <div class="header">Notifications</div>

    <div class="mt-4 title">Chats</div>
    <div class="horizontal-scroll">
      <div
        v-for="i in 5"
        :key="i"
        @click="$router.push({ name: 'ChatRoomMobile' })"
        class="horizontal-scroll__item relative pr-2 pb-2"
      >
        <img
          src="../../assets/mobile/icon/circle-red.svg"
          width="16"
          height="16"
          class="absolute circle-red"
        />
        <div class="horizontal-scroll__item__image">
          <img
            src="../../assets/mobile/notification.png"
            :width="156"
            :height="60"
          />
        </div>
      </div>
    </div>

    <div class="display-flex justify-space-between align-center mt-3">
      <div class="title">Inbox</div>
      <div class="see-all font-weight-500">See All</div>
    </div>
    <div class="horizontal-scroll">
      <div
        v-for="i in 5"
        :key="i"
        class="horizontal-scroll__item inbox mr-2 mb-2"
      >
        <div class="display-flex gap-8 align-center">
          <img
            src="../../assets/mobile/notification_1.png"
            :width="50"
            :height="50"
            class="rounded"
          />
          <div>
            <div class="text-inter-15">Andrew Parker</div>
            <div class="text-inter-13">
              <span>@andrewparker</span>
              <span class="text-black">• 24m</span>
            </div>
          </div>
        </div>
        <div class="text-inter-14 my-3">
          Yo bro, love your new album, are you down to come through for a
          session w..
        </div>
        <v-btn
          @click="$router.push({ name: 'MessagesMobile' })"
          class="text-inter-14 text-white inbox__btn"
          >Reply</v-btn
        >
      </div>
    </div>

    <div class="title mt-4">Activity</div>
    <div v-for="i in 5" :key="i">
      <div class="display-flex gap-8 align-center py-3">
        <img
          src="../../assets/mobile/notification_2.png"
          :width="50"
          :height="50"
          class="rounded"
        />
        <div class="display-flex justify-space-between algin-center full-width">
          <div class="text-inter-14 text-grey-6">
            <span class="font-weight-600">@patrick</span>
            <span class="font-weight-400">followed you</span>
          </div>
          <div class="text-inter-12 font-weight-400 text-grey-7">8h</div>
        </div>
      </div>

      <div class="display-flex justify-end">
        <hr class="line" />
      </div>
    </div>

    <div class="mb-5"></div>

    <Footer />
  </div>
</template>

<script>
import Footer from "./components/footer";

export default {
  components: {
    Footer,
  },
};
</script>

<style lang="scss" scoped>
.header {
  color: #272727;
  font-size: 22px;
  font-weight: 500;
  line-height: 70%;
  letter-spacing: -0.44px;
}
.title {
  color: #000;
  font-size: 18px;
  font-weight: 500;
  line-height: 80%;
  letter-spacing: -0.18px;
}

.horizontal-scroll {
  padding-top: 16px;
  &__item {
    &__image {
      border-radius: 10px;
      width: 156px;
      max-height: 60px;
      overflow: hidden;
    }
  }
  .circle-red {
    right: 8px;
    top: -8px;
  }
}

.see-all {
  color: rgba(0, 0, 0, 0.7);
  font-size: 16px;
  letter-spacing: -0.16px;
}

.inbox {
  border-radius: 10px;
  border: 0.5px solid rgba(0, 0, 0, 0.1);
  background: #fafafa;
  width: 309px;
  height: 200px;
  padding: 12px;
  &__btn {
    border-radius: 4px;
    background-color: #2e70e8 !important;
  }
}

.rounded {
  border-radius: 50px;
}

.line {
  width: calc(100% - 70px);
  opacity: 0.4;
}
</style>



// WEBPACK FOOTER //
// notification.vue?639ec318